import React from 'react';
import { createStyles, withStyles, Button } from '@material-ui/core';
import { TrashIcon } from '../Icons';
import {
  blockListing,
  removeBlockedListing,
  fetchBlockedListings,
} from './../../../actions/blocked';
import { fetchFavorites } from '../../../actions/favorite';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
  ClearSignupCallback,
  OpenSignupDialog,
} from './../../../actions/actionTypes';

const styles = createStyles({
  trashIcon: {
    borderRadius: 50,
    height: 24,
    minWidth: 25,
    padding: 0,
  },
});

interface Props {
  classes: any;
  index: any;
  listing: any;
  alreadyDeleted?: boolean;
  isLoved?: boolean;
  dispatch: any;
  token: string;
}

export class DeleteButton extends React.Component<Props> {
  blockAndRefresh = async (listing: any) => {
    await this.props.dispatch(blockListing(listing.id, this.props.token));
    this.props.dispatch(
      fetchFavorites(this.props.token, undefined, undefined, true),
    );
    this.props.dispatch(
      fetchBlockedListings(this.props.token, undefined, undefined, true),
    );
  };

  handleBlock = (event: any, listing: any, index: number) => {
    event.preventDefault();
    event.stopPropagation();
    const { alreadyDeleted, dispatch } = this.props;
    const deleteCallback = () => {
      if (alreadyDeleted) {
        // If already deleted, un-delete the listing
        dispatch(removeBlockedListing(listing.id, this.props.token));
      } else {
        // Re-fetching the favorites in case we have deleted a loved listing
        if (this.props.isLoved) {
          this.blockAndRefresh(listing);
        } else {
          dispatch(blockListing(listing.id, this.props.token));
        }
      }
    };

    if (!this.props.token) {
      dispatch({
        signupSubtext: `Sign up to save your favorite homes or block the ones you don’t want to see again.`,
        type: OpenSignupDialog,
        signupCallback: () => {
          deleteCallback(); // Callback function to execute after auth
          // Clear the callback from reducer
          dispatch({
            type: ClearSignupCallback,
          });
        },
      });
    } else {
      deleteCallback();
    }
  };

  render() {
    const { classes, listing, index } = this.props;
    return (
      <Button
        className={classes.trashIcon}
        onClick={event => this.handleBlock(event, listing, index)}
      >
        <TrashIcon light />
      </Button>
    );
  }
}

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(withStyles(styles)(DeleteButton));
